import React from 'react';
import RenderStatus from '../../../../../../utils/Render.js'

export default class AssetRow extends React.Component {
  /*constructor(props) {
    super(props);
  }*/
  
  render() {
		return (
			<tr>
				<td>{this.props.RowData.Name}</td>
				<td>{this.props.RowData.Location.Name}</td>
				<td>{this.props.RowData.Type.Name}</td>
				<td>{this.props.RowData.Status.Name}</td>
        		<td>{this.props.RowData.Owner.FirstName+' '+this.props.RowData.Owner.LastName}</td>
				<td className="text-center">
					{RenderStatus.MaintenaceStatus(this.props.RowData, this.props)}
				</td>
			</tr>
		);
	}
}


// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/component/table/row/AssetRow.js